<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Mark Filter Forms",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Filter Forms",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Filter Forms",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      allMarks: {
        class: "",
        term: "",
        year: "",
        stream: "",
      },
      setMarks: {
        class: "",
        term: "",
        year: "",
        stream: "",
        set: "",
      },
      subjectMarks: {
        class: "",
        term: "",
        year: "",
        stream: "",
        subject: "",
      },
      setSubjectMarks: {
        class: "",
        term: "",
        year: "",
        stream: "",
        set: "",
      },
    };
  },
  computed: {
    ...mapGetters("marks", ["getYears"]),
    ...mapGetters("classes", [
      "TeacherSubjects",
      "AllStreams",
      "AllClassStreams",
      "GetClassSubjects",
      "AllClasses",
      "SaveStatus",
    ]),
    ...mapGetters("coursework", ["AllSets"]),
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        // this.resetError();
        // this.closeModal(this.modal);
      }
    },
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows =
    //   this.getSpecificStudents.length > 0 ? this.getSpecificStudents.length : 1;
  },
  methods: {
    ...mapActions({
      FetchYears: "marks/fetchYear",
      FetchClasses: "classes/fetchClasses",
      FetchStreams: "classes/fetchStreams",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchClassSubjects: "classes/fetchClassSubjects",
      FetchSets: "coursework/fetchSets",
    }),

    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },
    fetchClassSub(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class subjects
      this.FetchClassSubjects(classSelected);
    },
    fetchStreamsSubject(event) {
      this.fetchStreamsinClass(event);
      this.fetchClassSub(event);
    },
    submitAllMarks() {
      var stream = 0;
      this.allMarks.stream ? (stream = this.allMarks.stream) : null;
      this.$router.push(
        `/marks/filter/allmarks/${this.allMarks.year}/${this.allMarks.term}/${this.allMarks.class}/${stream}`
      );
    },
    submitSetMarks() {
      var stream = 0;
      this.setMarks.stream ? (stream = this.setMarks.stream) : null;
      this.$router.push(
        `/marks/filter/setmarks/${this.setMarks.year}/${this.setMarks.term}/${this.setMarks.class}/${this.setMarks.set}/${stream}`
      );
    },
    submitSubjectMarks() {
      var stream = 0;
      this.subjectMarks.stream ? (stream = this.subjectMarks.stream) : null;
      this.$router.push(
        `/marks/filter/sujectmarks/${this.subjectMarks.year}/${this.subjectMarks.term}/${this.subjectMarks.class}/${this.subjectMarks.subject}/${stream}`
      );
    },
    submitSetSubjectMarks() {
      var stream = 0;
      this.setSubjectMarks.stream
        ? (stream = this.setSubjectMarks.stream)
        : null;
      this.$router.push(
        `/marks/filter/setsubjectmarks/${this.setSubjectMarks.year}/${this.setSubjectMarks.term}/${this.setSubjectMarks.class}/${this.setSubjectMarks.subject}/${this.setSubjectMarks.set}/${stream}`
      );
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchStreams();
    this.FetchSets();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Filter Forms, Select to filter marks.
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-md-12 custom-vert">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="card">
                          <div class="card-body row">
                            <div class="col-md-6 col-sm-6 mb-4">
                              <b-card no-body class="mb-1 shadow-none">
                                <b-card-header header-tag="header" role="tab">
                                  <h6 class="m-0">
                                    <a
                                      v-b-toggle="'accordion-' + 1"
                                      class="text-dark"
                                      href="javascript: void(0);"
                                    >
                                      FILTER MARKS FOR ALL EXAM SETS AND
                                      SUBJECTS
                                      <b class="float-right font-15">
                                        <i
                                          class="
                                            mdi mdi-chevron-down
                                            d-none d-xl-inline-block
                                          "
                                        ></i>
                                      </b>
                                      <div>
                                        <small>
                                          (This will display marks for all exam
                                          sets i.e. BOT, MID, EOT. This file can
                                          be use for marks at the end of term)
                                        </small>
                                      </div>
                                    </a>
                                  </h6>
                                </b-card-header>
                                <b-collapse
                                  :id="'accordion-' + 1"
                                  accordion="my-accordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-card-text>
                                      <div class="row mt-2 d-flex">
                                        <div class="col-md-10 mx-auto">
                                          <form
                                            @submit.prevent="submitAllMarks()"
                                          >
                                            <div class="row">
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Year</label
                                                  >
                                                  <select
                                                    class="form-control"
                                                    v-model="allMarks.year"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Year
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        schyear, index
                                                      ) in getYears"
                                                      :value="schyear.year"
                                                      :key="index"
                                                    >
                                                      {{ schyear.year }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Class</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="allMarks.class"
                                                    @change="
                                                      fetchStreamsinClass(
                                                        $event
                                                      )
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Class
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        classes, index
                                                      ) in AllClasses"
                                                      :key="index"
                                                      :value="classes.id"
                                                    >
                                                      {{ classes.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Term</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="allMarks.term"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Term
                                                    </option>
                                                    <option value="1">
                                                      Term 1
                                                    </option>
                                                    <option value="2">
                                                      Term 2
                                                    </option>
                                                    <option value="3">
                                                      Term 3
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Stream
                                                    <small class="text-primary"
                                                      >(Optional)</small
                                                    ></label
                                                  >
                                                  <select
                                                    class="form-control"
                                                    v-model="allMarks.stream"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Stream
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        stream, index
                                                      ) in AllClassStreams"
                                                      :value="stream.id"
                                                      :key="index"
                                                    >
                                                      {{ stream.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div class="col-md-12">
                                                <button
                                                  type="submit"
                                                  disabled
                                                  class="
                                                    btn
                                                    btn-sm
                                                    btn-outline-primary
                                                    float-end
                                                  "
                                                  v-if="SaveStatus"
                                                >
                                                  <b-spinner
                                                    variant="primary"
                                                    small
                                                    label="Fetching Data..."
                                                  ></b-spinner>
                                                  Fetching Data...
                                                </button>
                                                <button
                                                  v-else
                                                  type="submit"
                                                  size="sm"
                                                  class="
                                                    btn
                                                    btn-sm
                                                    btn-outline-primary
                                                    float-end
                                                  "
                                                >
                                                  <i class="fa fa-check"></i>
                                                  Submit Filers
                                                </button>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                            <div class="col-md-6 col-sm-6 mb-4">
                              <b-card no-body class="mb-1 shadow-none">
                                <b-card-header header-tag="header" role="tab">
                                  <h6 class="m-0">
                                    <a
                                      v-b-toggle="'accordion-' + 2"
                                      class="text-dark"
                                      href="javascript: void(0);"
                                    >
                                      FILTER MARKS FOR EXAM SETS
                                      <b class="float-right font-15">
                                        <i
                                          class="
                                            mdi mdi-chevron-down
                                            d-none d-xl-inline-block
                                          "
                                        ></i>
                                      </b>
                                      <div>
                                        <small>
                                          (This will display marks for all
                                          subjects, depending on the selected
                                          exam set)
                                        </small>
                                      </div>
                                    </a>
                                  </h6>
                                </b-card-header>
                                <b-collapse
                                  :id="'accordion-' + 2"
                                  accordion="my-accordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-card-text>
                                      <div class="row mt-2 d-flex">
                                        <div class="col-md-10 mx-auto">
                                          <form
                                            @submit.prevent="submitSetMarks()"
                                          >
                                            <div class="row">
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Year</label
                                                  >
                                                  <select
                                                    class="form-control"
                                                    v-model="setMarks.year"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Year
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        schyear, index
                                                      ) in getYears"
                                                      :value="schyear.year"
                                                      :key="index"
                                                    >
                                                      {{ schyear.year }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Term</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="setMarks.term"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Term
                                                    </option>
                                                    <option value="1">
                                                      Term 1
                                                    </option>
                                                    <option value="2">
                                                      Term 2
                                                    </option>
                                                    <option value="3">
                                                      Term 3
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Class</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="setMarks.class"
                                                    @change="
                                                      fetchStreamsinClass(
                                                        $event
                                                      )
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Class
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        classes, index
                                                      ) in AllClasses"
                                                      :key="index"
                                                      :value="classes.id"
                                                    >
                                                      {{ classes.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Exam Set</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="setMarks.set"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Exam Set
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        set, index
                                                      ) in AllSets"
                                                      :key="index"
                                                      :value="set.id"
                                                    >
                                                      {{ set.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Stream
                                                    <small class="text-primary"
                                                      >(Optional)</small
                                                    ></label
                                                  >
                                                  <select
                                                    class="form-control"
                                                    v-model="setMarks.stream"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Stream
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        stream, index
                                                      ) in AllClassStreams"
                                                      :value="stream.id"
                                                      :key="index"
                                                    >
                                                      {{ stream.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div class="col-md-12">
                                                <button
                                                  type="submit"
                                                  disabled
                                                  class="
                                                    btn
                                                    btn-sm
                                                    btn-outline-primary
                                                    float-end
                                                  "
                                                  v-if="SaveStatus"
                                                >
                                                  <b-spinner
                                                    variant="primary"
                                                    small
                                                    label="Fetching Data..."
                                                  ></b-spinner>
                                                  Fetching Data...
                                                </button>
                                                <button
                                                  v-else
                                                  type="submit"
                                                  class="
                                                    btn
                                                    btn-sm
                                                    btn-outline-primary
                                                    float-end
                                                  "
                                                >
                                                  <i class="fa fa-check"></i>
                                                  Submit Filers
                                                </button>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                            <div class="col-md-6 col-sm-6 mb-4">
                              <b-card no-body class="mb-1 shadow-none">
                                <b-card-header header-tag="header" role="tab">
                                  <h6 class="m-0">
                                    <a
                                      v-b-toggle="'accordion-' + 3"
                                      class="text-dark"
                                      href="javascript: void(0);"
                                    >
                                      FILTER MARKS FOR SPECIFIC SUBJECTS
                                      <b class="float-right font-15">
                                        <i
                                          class="
                                            mdi mdi-chevron-down
                                            d-none d-xl-inline-block
                                          "
                                        ></i>
                                      </b>
                                      <div>
                                        <small>
                                          (This will display marks for specific
                                          subjects and for all exam sets)
                                        </small>
                                      </div>
                                    </a>
                                  </h6>
                                </b-card-header>
                                <b-collapse
                                  :id="'accordion-' + 3"
                                  accordion="my-accordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-card-text>
                                      <div class="row mt-2 d-flex">
                                        <div class="col-md-10 mx-auto">
                                          <form
                                            @submit.prevent="
                                              submitSubjectMarks()
                                            "
                                          >
                                            <div class="row">
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Year</label
                                                  >
                                                  <select
                                                    class="form-control"
                                                    v-model="subjectMarks.year"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Year
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        schyear, index
                                                      ) in getYears"
                                                      :value="schyear.year"
                                                      :key="index"
                                                    >
                                                      {{ schyear.year }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Class</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="subjectMarks.class"
                                                    @change="
                                                      fetchStreamsSubject(
                                                        $event
                                                      )
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Class
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        classes, index
                                                      ) in AllClasses"
                                                      :key="index"
                                                      :value="classes.id"
                                                    >
                                                      {{ classes.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Term</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="subjectMarks.term"
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Term
                                                    </option>
                                                    <option value="1">
                                                      Term 1
                                                    </option>
                                                    <option value="2">
                                                      Term 2
                                                    </option>
                                                    <option value="3">
                                                      Term 3
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Subject</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="
                                                      subjectMarks.subject
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      v-if="SaveStatus"
                                                    >
                                                      Fetching Subjects...
                                                    </option>
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      v-else
                                                    >
                                                      Select Subject
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        subject, index
                                                      ) in GetClassSubjects"
                                                      :key="index"
                                                      :value="subject.id"
                                                    >
                                                      {{ subject.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Stream
                                                    <small class="text-primary"
                                                      >(Optional)</small
                                                    ></label
                                                  >
                                                  <select
                                                    class="form-control"
                                                    v-model="
                                                      subjectMarks.stream
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      v-if="SaveStatus"
                                                    >
                                                      Fetching Streams...
                                                    </option>
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      v-else
                                                    >
                                                      Select Stream
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        stream, index
                                                      ) in AllClassStreams"
                                                      :value="stream.id"
                                                      :key="index"
                                                    >
                                                      {{ stream.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div class="col-md-12">
                                                <button
                                                  type="submit"
                                                  size="sm"
                                                  disabled
                                                  class="
                                                    btn
                                                    btn-sm
                                                    btn-outline-primary
                                                    float-end
                                                  "
                                                  v-if="SaveStatus"
                                                >
                                                  <b-spinner
                                                    variant="primary"
                                                    small
                                                    label="Fetching Data..."
                                                  ></b-spinner>
                                                  Fetching Data...
                                                </button>
                                                <button
                                                  v-else
                                                  type="submit"
                                                  size="sm"
                                                  class="
                                                    btn
                                                    btn-sm
                                                    btn-outline-primary
                                                    float-end
                                                  "
                                                >
                                                  <i class="fa fa-check"></i>
                                                  Submit Filers
                                                </button>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                            <div class="col-md-6 col-sm-6 mb-4">
                              <b-card no-body class="mb-1 shadow-none">
                                <b-card-header header-tag="header" role="tab">
                                  <h6 class="m-0">
                                    <a
                                      v-b-toggle="'accordion-' + 4"
                                      class="text-dark"
                                      href="javascript: void(0);"
                                    >
                                      FILTER MARKS FOR SPECIFIC SUBJECTS AND
                                      SETS
                                      <b class="float-right font-15">
                                        <i
                                          class="
                                            mdi mdi-chevron-down
                                            d-none d-xl-inline-block
                                          "
                                        ></i>
                                      </b>
                                      <div>
                                        <small>
                                          (This will display marks for specific
                                          subjects and for all exam sets)
                                        </small>
                                      </div>
                                    </a>
                                  </h6>
                                </b-card-header>
                                <b-collapse
                                  :id="'accordion-' + 4"
                                  accordion="my-accordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-card-text>
                                      <div class="row mt-2 d-flex">
                                        <div class="col-md-10 mx-auto">
                                          <form
                                            @submit.prevent="
                                              submitSetSubjectMarks()
                                            "
                                          >
                                            <div class="row">
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Year</label
                                                  >
                                                  <select
                                                    class="form-control"
                                                    v-model="
                                                      setSubjectMarks.year
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Year
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        schyear, index
                                                      ) in getYears"
                                                      :value="schyear.year"
                                                      :key="index"
                                                    >
                                                      {{ schyear.year }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Class</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="
                                                      setSubjectMarks.class
                                                    "
                                                    @change="
                                                      fetchStreamsSubject(
                                                        $event
                                                      )
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Class
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        classes, index
                                                      ) in AllClasses"
                                                      :key="index"
                                                      :value="classes.id"
                                                    >
                                                      {{ classes.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Term</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="
                                                      setSubjectMarks.term
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Term
                                                    </option>
                                                    <option value="1">
                                                      Term 1
                                                    </option>
                                                    <option value="2">
                                                      Term 2
                                                    </option>
                                                    <option value="3">
                                                      Term 3
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Exam Set</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="
                                                      setSubjectMarks.set
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                    >
                                                      Select Exam Set
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        set, index
                                                      ) in AllSets"
                                                      :key="index"
                                                      :value="set.id"
                                                    >
                                                      {{ set.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Subject</label
                                                  >
                                                  <select
                                                    required
                                                    class="form-control"
                                                    v-model="
                                                      setSubjectMarks.subject
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      v-if="SaveStatus"
                                                    >
                                                      Fetching Subjects...
                                                    </option>
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      v-else
                                                    >
                                                      Select Subject
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        subject, index
                                                      ) in GetClassSubjects"
                                                      :key="index"
                                                      :value="subject.id"
                                                    >
                                                      {{ subject.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div
                                                class="
                                                  form-group
                                                  col-md-12
                                                  mb-3
                                                "
                                              >
                                                <div class="form-group">
                                                  <label for=""
                                                    >Select Stream
                                                    <small class="text-primary"
                                                      >(Optional)</small
                                                    ></label
                                                  >
                                                  <select
                                                    class="form-control"
                                                    v-model="
                                                      setSubjectMarks.stream
                                                    "
                                                    name=""
                                                    id=""
                                                  >
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      v-if="SaveStatus"
                                                    >
                                                      Fetching Streams...
                                                    </option>
                                                    <option
                                                      value=""
                                                      selected
                                                      disabled
                                                      v-else
                                                    >
                                                      Select Stream
                                                    </option>
                                                    <option
                                                      v-for="(
                                                        stream, index
                                                      ) in AllClassStreams"
                                                      :value="stream.id"
                                                      :key="index"
                                                    >
                                                      {{ stream.name }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div class="col-md-12">
                                                <button
                                                  type="submit"
                                                  disabled
                                                  class="
                                                    btn
                                                    btn-sm
                                                    btn-outline-primary
                                                    float-end
                                                  "
                                                  v-if="SaveStatus"
                                                >
                                                  <b-spinner
                                                    variant="primary"
                                                    small
                                                    label="Fetching Data..."
                                                  ></b-spinner>
                                                  Fetching Data...
                                                </button>
                                                <button
                                                  v-else
                                                  type="submit"
                                                  class="
                                                    btn
                                                    btn-sm
                                                    btn-outline-primary
                                                    float-end
                                                  "
                                                >
                                                  <i class="fa fa-check"></i>
                                                  Submit Filers
                                                </button>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </b-card-text>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
